import React from "react";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import USPs from "@/components/USPs";
import IndustriesStrip from "@/components/IndustriesStrip";
import ProductGallery from "@/components/ProductGallery";
import ProcessTimeline from "@/components/ProcessTimeline";
import WhyUs from "@/components/WhyUs";
import Testimonials from "@/components/Testimonials";
import QuoteForm from "@/components/QuoteForm";
import Footer from "@/components/Footer";
import WhatsAppFab from "@/components/WhatsAppFab";

export default function LandingPage() {
  return (
    <div
      data-testid="landing-page"
      className="min-h-screen bg-white text-[#0a1128]"
    >
      <Navbar />
      <main>
        <Hero />
        <IndustriesStrip />
        <USPs />
        <ProductGallery />
        <ProcessTimeline />
        <WhyUs />
        <Testimonials />
        <QuoteForm />
      </main>
      <Footer />
      <WhatsAppFab />
    </div>
  );
}
